import { createAsyncAction, hydrateAction } from 'src/redux/actions';
import { user } from 'src/sections/profile/schemas';
import { urls } from 'src/urls/search';

export const LoadSearchPage = createAsyncAction('search/LOAD_PAGE');

export const loadSearchPage = (workspaceSlug?: string) =>
  hydrateAction(LoadSearchPage, 'search', {
    url: urls.ui.search(workspaceSlug),
    schema: {
      accounts: [user],
    },
  });
